import { DataGrid } from "@mui/x-data-grid";
import {
  fKeyTabInput,
  hasValueInErrorMessage,
} from "../../../Utility/Utilitys";
import {
  CmpDatePickerField,
  CmpSelectField,
  CmpSelectArrField,
  CmpInputField,
  CmpCheckboxField,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";

import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import Grid from "@mui/material/Grid";
import { CmpDatePickerField001V1, CmpSelectArrFieldV1, CmpSelectFieldV1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";

// import Modal from "@mui/material/Modal";
// import Box from '@mui/material/Box';

export default function GCHead({
  fOpenERPStockModal,
  xItemStock,
  vRdxSalesQuotationHead,
  sLocation,
  DocLoading,
  currency,
  selecType,
  fOpenHeadCustomerSearchModalKey,
  sPayModeArr,
  fOnChangeSelectDocType,
  fOnChangeSelectCurr,
  fOnChangeInputDate,
  fOnChangeInputDateRefDate,
  fonChangeInput,
  fonChangeInputTaxType,
  fonChangeInputPayMode,
  fonChangeInputTaxable,
  fonChangeInputLocation,
  fonChangeInputCustomer,
  sErrorMsg,
  sDetailGridData,
  sToggleGrid,
  GridDataSalesHistoryColumns,
  sGridSalesHistoryRowData,
  vMediaQuery,

  xcolumnsDropdownSearch,
  xrowDropdownSearch,
  xOnCellKeyDown,
  xOnRowClick,
  xToggleDropdown,
  xhandleClick,
  inputReference,
  xData,
  xOnChange,
  xDropdownObj,
  xOnKeyUp,
  xPaymodeEnable,
  xOsAmount = "",
  sTax,
}) {
  return (
    <div className="Wms-sales-invoice-head">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0, md: 0 }}
        columnSpacing={{ xs: 0.9, sm: 0, md: 0.5 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        sx={{ marginTop: { md: "0px", sm: "0px", xs: "10px" } }}
      
      >
        <Grid item xs={12} sm={12} md={4.5}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(sErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            
            <Grid item xs={12} sm={3} md={6}>
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxSalesQuotationHead.A_VocTyp}
                xOnChange={(e) => {
                  fOnChangeSelectDocType(e);
                }}
                xName={"A_VocTyp"}
                xData={DocLoading}
                xValueMember={""}
                xDispalyMember={""}
                xError={sErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={sErrorMsg.A_VocTyp}
                xDisable={sDetailGridData.length > 0 || vRdxSalesQuotationHead.A_VocNo !=0}
                // xOnKeyUp={xKey}
              />
            </Grid>
           
            <Grid item xs={12} sm={3} md={6}>
              <CmpTextFieldV1
               xLabelText="Doc.No"
                xSize="small"
                xValue={vRdxSalesQuotationHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={sErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={sErrorMsg.A_VocNo}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "A_PostDt");
                }}
              />
            </Grid>
 
            <Grid item xs={12} sm={3} md={3}>
              <CmpDatePickerField001V1
              xLabelText="Doc.Date"
                xtabIndex={"2"}
                xref={inputReference}
                // xValue={vRdxWmsHead.A_PostDt}
                xValue={vRdxSalesQuotationHead.A_PostDt}
                xOnChange={fOnChangeInputDate}
                xName={"A_PostDt"}
                xError={sErrorMsg.A_PostDt === "" ? false : true}
                xErrorMessage={sErrorMsg.A_PostDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_RefDocNo");
                // }}
              />
            </Grid>
            
            <Grid item xs={6} sm={3} md={3}>
              <CmpDatePickerField001V1
                xLabelText="Valid Upto" 
                xValue={vRdxSalesQuotationHead.A_RefDt}
                xOnChange={(e) => {
                  fOnChangeInputDateRefDate(e);
                }}
                xName={"A_RefDt"}
                xError={sErrorMsg.A_RefDt === "" ? false : true}
                xErrorMessage={sErrorMsg.A_RefDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
              />
            </Grid>
            <Grid item xs={6} sm={3} md={6}>
              <CmpTextFieldV1
              xLabelText="RefNo"
                xSize="small"
                xtabIndex={"3"}
                xValue={vRdxSalesQuotationHead.A_RefNo}
                xType={"text"} // text/number/password
                xName={"A_RefNo"}
                xReadOnly={false}
                xOnChange={(e) => {
                  fonChangeInput(e);
                }}
                xError={sErrorMsg.A_RefNo === "" ? false : true}
                xErrorMessage={sErrorMsg.A_RefNo}
                // xOnKeyUp={xKey}
              />
            </Grid>   
            <Grid item xs={6} sm={3} md={3}>
                <CmpSelectFieldV1
                  xLabelText="Currency"
                  xValue={vRdxSalesQuotationHead.A_Curr}
                  xOnChange={fOnChangeSelectCurr}
                  xName={"A_Curr"}
                  xData={currency}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_Curr === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_Curr}
                  xDisable={sDetailGridData.length > 0}
                  // xDisable={true}
                />
              </Grid>
              
              <Grid item xs={6} sm={3} md={3}>
                <CmpTextFieldV1
              xLabelText="ExRate"
                xSize="small"
                  xValue={vRdxSalesQuotationHead.A_ExRate}
                  xType={"number"} // text/number/password
                  xName={"A_ExRate"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                  // xOnKeyUp={(e) => {
                  //   xFocusInput("A_LocName");
                  // }}
                />
              </Grid>
               
              <Grid item xs={6} sm={3} md={3}>
                <CmpSelectArrFieldV1
                  xLabelText="Paymode"
                  xValue={vRdxSalesQuotationHead.A_PayMode}
                  xOnChange={(e) => {
                    fonChangeInputPayMode(e);
                  }}
                  xName={"A_PayMode"}
                  xData={sPayModeArr}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_PayMode === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_PayMode}
                  xDisable={false}
                />
              </Grid>       
           
            <Grid item xs={4} sm={4} md={2} className=" p-left-label ">
              <span
                className={
                  vRdxSalesQuotationHead.A_DocStat === "ENTER"
                    ? "txt-overflow-wms "
                    : "hide-content"
                }
                title={xItemStock?.rpStock}
                onClick={fOpenERPStockModal}
              >
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"ERP: " + xItemStock?.rpStock}
                />{" "}
              </span>
            </Grid>
            
          </Grid>
        </Grid>
        {sToggleGrid ? (
          <Grid item xs={12} sm={12} md={7} lg={7}>
            <Grid
              container
              spacing={0}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className="align-items-start"
            >
              <div style={{ height: 170, width: "100%" }}>
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sGridSalesHistoryRowData}
                  columns={GridDataSalesHistoryColumns}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  // onRowClick={fonRowClickGridObj}
                  hideFooter={sGridSalesHistoryRowData.length < 100}
                />
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12} sm={12} md={7.5}>
            <Grid
              container
              spacing={0.9}
              columnSpacing={{ xs: 0, sm: 0.9, md: 0.2 }}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className={
                hasValueInErrorMessage(sErrorMsg)
                  ? "align-items-center"
                  : "align-items-start"
              }
            >
             
              <Grid item xs={12} sm={8} md={12}>
                <Grid container spacing={0.9}>
                {!vMediaQuery&&  <Grid item xs={12} sm={3} md={2} lg={2}  >
                <CmpTextFieldV1
              xLabelText="Customer"
                xSize="small"
                      xValue={vRdxSalesQuotationHead.A_Party}
                      xType={"text"} // text/number/password
                      xName={"A_Party"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={sErrorMsg.A_Party === "" ? false : true}
                      xErrorMessage={sErrorMsg.A_Party}
                    />
                  </Grid>}
                  <Grid
                    item
                    xs={12}
                    sm={9}
                    md={10}
                    className="dropDowntoggle"
                  >
                    <GCToggleSearchV1
                       xLabelText="Customer Name"
                      xName={"A_PartyName"}
                      xType={"text"}
                      xValue={vRdxSalesQuotationHead.A_PartyName}
                      xReadOnly={false}
                      xOnChange={(e) => {
                        fonChangeInputCustomer(e);
                      }} //GCToggleSearch onchange main input
                      xOnKeyUp={(e) => {
                        fOpenHeadCustomerSearchModalKey(e, "customer");
                      }} //GCToggleSearch xOnKeyUp main input
                      xError={sErrorMsg.A_PartyName === "" ? false : true}
                      xErrorMessage={sErrorMsg.A_PartyName}
                      xMediaQuery={false}
                      xonClickbtn={xhandleClick} // GCToggleSearch onclick icon open div on main screen
                      xrows={xrowDropdownSearch} //GCToggleSearch-grid
                      xcolumns={xcolumnsDropdownSearch} //GCToggleSearch-grid
                      xRowCellClick={xOnCellKeyDown}
                      xRowClick={xOnRowClick}
                      xToggle={xToggleDropdown} //GCToggleSearch- true/false
                      xData={xData} //GCToggleSearch-select
                      xOnChangeDropdownInput={xOnChange} //GCToggleSearch -input
                      xDropdownObj={xDropdownObj} //GCToggleSearch -obj
                      xOnKeyUpDropdownInput={xOnKeyUp} //GCToggleSearch -Enter key and clickc detect
                      xtabIndex="5"
                    />
                  </Grid>
                </Grid>
              </Grid>
              
            
              
             
              <Grid item xs={6} sm={4} md={3}>
                <CmpSelectArrFieldV1
                  xLabelText="Type"
                  xValue={vRdxSalesQuotationHead.A_Type}
                  xOnChange={(e) => {
                    fonChangeInput(e);
                  }}
                  xName={"A_Type"}
                  xData={selecType}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_Type === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_Type}
                  xDisable={sDetailGridData.length > 0}
                  xtabIndex={"6"}
                />
              </Grid>
             
              <Grid item xs={6} sm={3} md={3}>
                <CmpSelectFieldV1
                  xLabelText="Location"
                  xValue={vRdxSalesQuotationHead.A_Loc}
                  xOnChange={(e) => {
                    fonChangeInputLocation(e);
                  }}
                  xName={"A_Loc"}
                  xData={sLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_Loc === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_Loc}
                  xDisable={sDetailGridData.length > 0}
                />
              </Grid>
             
            
              
              <Grid item xs={6} sm={3} md={3}>
                <CmpSelectFieldV1
                  xLabelText="Tax Type"
                  xValue={vRdxSalesQuotationHead?.A_CUSTFIELD3}
                  xOnChange={(e) => {
                    fonChangeInputTaxType(e);
                  }}
                  xName={"A_CUSTFIELD3"}
                  xData={sTax}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_CUSTFIELD3 === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_CUSTFIELD3}
                  // xDisable={sDetailGridData.length > 0} client
                  xDisable={true}
                />
              </Grid>


              <Grid item xs={6} sm={3} md={3} >
                <CmpCheckboxField
                  xChecked={vRdxSalesQuotationHead.A_Taxable === "Y"}
                  xOnChange={fonChangeInputTaxable}
                  xDisabled={true}
                  xName={"A_Taxable"}
                  xNameField={"Tax"}
                  xError={sErrorMsg.A_Taxable === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_Taxable}
                />
              </Grid>

              {vRdxSalesQuotationHead.A_DocStat === "ENTER" ? (
                <>
                  <Grid item xs={6} sm={4} md={3}>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"Net O/s Amt = " + xOsAmount.NetOsAmt}
                    />
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"PDC Amt = " + xOsAmount.PDCAmt}
                    />
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"Balance O/s Amt = " + xOsAmount.BalanceOsAmt}
                    />
                  </Grid>
                   
                  
                  
                </>
              ) : (
                ""
              )}

           
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
